import { apiEnv } from '@mgmresorts/wcl-utils';
import React from 'react';

export interface BackdropShowOptions {
  loading?: boolean;
  transitionDuration?: number;
  backgroundColor?: string;
  zIndex: number;
  onClick?: () => void;
}

export interface BackdropContextValue {
  initialized: boolean;
  activeBackdrop?: {
    id: string;
    transitionDuration: number;
    backgroundColor?: string;
    zIndex: number;
    onClick?: () => void;
  };

  show(options: BackdropShowOptions): string;
  hide(backdropId: string): void;
}

export const BackdropContext = React.createContext<BackdropContextValue>({
  initialized: false,
  show() {
    if (apiEnv === 'test') {
      return 'test';
    }

    throw new TypeError(`BackdropContext isn't initialized`);
  },
  hide() {
    if (apiEnv === 'test') {
      return;
    }

    throw new TypeError(`BackdropContext isn't initialized`);
  },
});
